const VideosHouse = [
  {
    video_id: "JAwyisVxXIg",
    title: "Vox",
    artist: "Cocolores",
  },
  {
    video_id: "HY1O6q4s_Jk",
    title: "Equal Responsibility (Betoko Remix)",
    artist: "Climbers",
  },
  {
    video_id: "iWiilOH4cQE",
    title: "Liquid Spirit (Claptone Remix)",
    artist: "Gregory Porter",
  },
  {
    video_id: "Mw-tUHNJYvg",
    title: "Siren (Audiojack Remix)",
    artist: "Definition, Natascha Polké",
  },
  {
    video_id: "L_GFS1yhWhM",
    title: "Save Our Soul",
    artist: "Bob Sinclar",
  },
  {
    video_id: "MrhzZp7YFms",
    title: "Pearls (Einst82 Rmx)",
    artist: "Sade",
  },
  {
    video_id: "kr0_YzOQf5A",
    title: "Adieu",
    artist: "Tchami",
  },
  {
    video_id: "9vFYB8EKesw",
    title: "Every Single Piece",
    artist: "Redondo & Bolier Feat. She Keeps Bees",
  },
  {
    video_id: "6dd0AItGAOs",
    title: "Space Invader",
    artist: "Betoko",
  },
  {
    video_id: "Nszhk40YREY",
    title: "You Picked Me",
    artist: "Sombionx & Andy Stroble",
  },
  {
    video_id: "fDG28N9mAjM",
    title: "Soul 2 Let Go (Ed Funk & Sir Piers Vocal Mix)",
    artist: "Derrick White",
  },
  {
    video_id: "UCJZSI5Iuo4",
    title: "Get a Life",
    artist: "Fritz Kalkbrenner",
  },
  {
    video_id: "HY-8lkCzxOY",
    title: "Like You (Audiojack Ruff Cut)",
    artist: "Hot Since 82",
  },
  {
    video_id: "zH_0uajkyCE",
    title: "Feel for you (MERCER Remix)",
    artist: "Bob Sinclar",
  },
  {
    video_id: "neIJC_SPO_0",
    title: "No Eyes",
    artist: "CLAPTONE",
  },
  {
    video_id: "J9P-cXVEwIQ",
    title: "Atlas",
    artist: "Chris Stussy",
  },
  {
    video_id: "mol5CjnFNjU",
    title: "Baptême",
    artist: "Agoria",
  },
  {
    video_id: "Ypydbqn1bK0",
    title: "Angel",
    artist: "Noir & Hayze",
  },
  {
    video_id: "GHLTQWoo-co",
    title: "Hey Now (Sasha Remix)",
    artist: "London Grammar",
  },
  {
    video_id: "iHSLh8-Ijw8",
    title: "Cream",
    artist: "Claptone",
  },
  {
    video_id: "NgyAa1AfShg",
    title: "Love Matters",
    artist: "Fat Sushi",
  },
  {
    video_id: "FB7t9bY98vM",
    title: "World Hold On (Tom Staar Remix)",
    artist: "Bob Sinclar ft. Steve Edwards",
  },
  {
    video_id: "o7fgUDJ8KHY",
    title: "Sumo Acid Crew",
    artist: "Palms Trax",
  },
  {
    video_id: "KRH05Nq_JI0",
    title: "Deep Inside",
    artist: "Hardrive",
  },
  {
    video_id: "FmHe5he7QR4",
    title: "Blinded By The Sun",
    artist: "Phil Kieran",
  },
  {
    video_id: "7bMYhJ_UqnE",
    title: "Around (Solomun Vox Mix)",
    artist: "Noir & Haze",
  },
  {
    video_id: "jCkjU-2RPeY",
    title: "Drop The Pressure (Sonny Fodera Remix)",
    artist: "Claptone & Mylo",
  },
  {
    video_id: "jNMt5BV_7MY",
    title: "Lost tape",
    artist: "Mutual Attraction",
  },
  {
    video_id: "bZtgsUHdwP4",
    title: "Flutes (Sasha remix)",
    artist: "Hot Chip",
  },
  {
    video_id: "BdVlfpPAqyk",
    title: "One day / Reckoning Song (Wankelmut Remix)",
    artist: "Asaf Avidan",
  },
  {
    video_id: "nrednGxuO0s",
    title: "Safe the Energy",
    artist: "Christopher Rau",
  },
  {
    video_id: "z4Sv4dXYpFg",
    title: "B2",
    artist: "Cobblestone Jazz",
  },
  {
    video_id: "9ojuFX3M1KI",
    title: "Make Me Feel",
    artist: "Claptone",
  },
];

export default VideosHouse;
